'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { List as ListComponent } from '../list/index.js';

/**
 * ErrorSummary list component, used to display a list of errors.
 *
 * @example
 * <ErrorSummary>
 *   <ErrorSummary.List>
 *     <ErrorSummary.Item>
 *       <ErrorSummary.Link href='#'>Error 1</ErrorSummary.Link>
 *     </ErrorSummary.Item>
 *     <ErrorSummary.Item>
 *       <ErrorSummary.Link href='#'>Error 2</ErrorSummary.Link>
 *     </ErrorSummary.Item>
 *   </ErrorSummary.List>
 * </ErrorSummary>
 */
const ErrorSummaryList = forwardRef(function ErrorSummaryList({ ...rest }, ref) {
    return jsx(ListComponent.Unordered, { ...rest, ref: ref });
});

export { ErrorSummaryList };
